<template>
  <div class="conges-calendar-view">
    <Header title="Calendrier des congés" />
    
    <div class="calendar-content">
      <div class="calendar-intro">
        <h4>📅 Visualisation des congés</h4>
        <p>Consultez les congés planifiés pour l'ensemble du personnel par mois.</p>
      </div>
      
      <div class="calendar-container">
        <CongesCalendar />
      </div>
      
      <div class="calendar-legend">
        <h5>Légende</h5>
        <div class="legend-items">
          <div class="legend-item">
            <div class="legend-color" style="background-color: #fff8e1;"></div>
            <span>En attente</span>
          </div>
          <div class="legend-item">
            <div class="legend-color" style="background-color: #e8f5e9;"></div>
            <span>Approuvé</span>
          </div>
          <div class="legend-item">
            <div class="legend-color" style="background-color: #ffebee;"></div>
            <span>Refusé</span>
          </div>
          <div class="legend-item">
            <div class="legend-color" style="background-color: #f5f5f5;"></div>
            <span>Annulé</span>
          </div>
          <div class="legend-item">
            <div class="legend-color" style="background-color: #e0f7f4;"></div>
            <span>Aujourd'hui</span>
          </div>
          <div class="legend-item">
            <div class="legend-color" style="background-color: #ffebee;"></div>
            <span>Jour férié</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import Header from '@/components/Header.vue';
import CongesCalendar from '@/components/conges/CongesCalendar.vue';

onMounted(() => {
  document.title = 'OpSolver - Calendrier des congés';
});
</script>

<style scoped>
.conges-calendar-view {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.calendar-content {
  flex: 1;
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
}

.calendar-intro {
  margin-bottom: 20px;
}

.calendar-intro h4 {
  font-size: 1.3rem;
  color: #455a64;
  margin-bottom: 10px;
  padding-bottom: 15px;
  border-bottom: 1px solid #e0e0e0;
}

.calendar-intro p {
  color: #78909c;
  margin-bottom: 20px;
}

.calendar-container {
  margin-bottom: 30px;
}

.calendar-legend {
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  padding: 20px;
}

.calendar-legend h5 {
  font-size: 1.1rem;
  color: #455a64;
  margin-bottom: 15px;
}

.legend-items {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.legend-color {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
}
</style>
